<template>
  <div>
      <div class="order-status-container">
          <figure :class="getClass">
            <i :class="getIcon"></i>
          </figure>
          <span>{{ getLabel }}</span>
      </div>
      <div class="modal">

      </div>
  </div>
</template>
<script>

export default {
  name: 'OrderStatus',
  props: ['type','icon','label','className'],
  data: function () {
    return {
      propLabel: "",
      propClass: "",
      propIcon: "",
      statusTypes: {
        in_progress: {
          label: "En traitement",
          class: "in_progress",
          icon: "icon icon-order-pending",
        },
        pending: {
          label: "En attente",
          class: "pending",
          icon: "icon icon-icon_clock",
        },
        draft: {
          label: "Brouillon",
          class: "draft",
          icon: "icon icon-order-pending",
        },
        shipped: {
          label: "Envoyé",
          class: "success",
          icon: "icon icon-order-success",
        },
        delivered: {
          label: "Terminé",
          class: "success",
          icon: "icon icon-order-success",
        },
        terminated: {
          label: "Terminé",
          class: "success",
          icon: "icon icon-order-success",
        },
        transporter_informed: {
          label: "En traitement",
          class: "in_progress",
          icon: "icon icon-order-pending",
        },
        completed: {
          label: "Payé",
          class: "success",
          icon: "icon icon-order-success",
        },
        canceled: {
          label: "Annulé",
          class: "error",
          icon: "icon icon-order-cancel",
        },
        error: {
          label: "Annulé",
          class: "error",
          icon: "icon icon-order-cancel",
        },
        success: {
          label: "Terminé",
          class: "success",
          icon: "icon icon-order-completed",
        },
        refunded: {
          label: "Remboursé",
          class: "error",
          icon: "icon icon-order-cancel",
        },
        started: {
          label: "En attente",
          class: "pending",
          icon: "icon icon-icon_clock",
        },
      }
    }
  },
  computed: {
    getClass () {
      return {
        "order-state": true,
        [(this.statusTypes[this.type]? this.statusTypes[this.type].class : "")]: true
      }
    },
    getLabel() {
      return  this.statusTypes[this.type]? this.statusTypes[this.type].label : ""
    },
    getIcon() {
      return  this.statusTypes[this.type]? this.statusTypes[this.type].icon : ""
    }


  }
}
</script>





// WEBPACK FOOTER //
// src/components/OrderStatus.vue